import React from 'react';
import './App.css';
import showcase from './showcase.png';
import scheduling from './scheduling.png';

function App() {
  return (
    <div className="App">
			<div className="App-header">
				<a href="https://github.com/scotch115/daily.git" style={{position: "relative", right: "25vw", top: "8vw", color: "white"}}>Daily</a>
				<p style={{position: "relative", left: "20vw", width: "40vw", fontSize: "calc(20px + 1vw)", top: "10vw", textAlign: "left", color: "white", fontWeight: "200"}}>A tasks app built on Flutter</p>
				<div
					style={{
						position: "absolute",
						right: "10vw",
						top: "18rem",
						color: "white",
						fontSize: "3vw"
					}}
				>
					Try it out <a href="https://daily-ios-app.web.app" style={{ color: 'white' }}>here</a> !
				</div>
				<img alt="main app" width="100%" src={showcase} ></img>
			</div>
			<div style={{backgroundColor: "white", position: "relative", width: "100%", height: "5vh", top: "-5px"}}></div>
			<div style={{fontWeight: "700", fontSize: "50px", position: "relative", bottom: "10%"}}>Features</div>
			<div style={{position: 'relative', paddingTop: '10px'}}>
				<img alt="screenshots" width="80%" style={{position: "relative", top: "20%", bottom: "8vh"}} src={scheduling}></img>
			</div>
			<div style={{position: 'relative', paddingTop: '10px'}}>
				<a href="https://apps.apple.com/us/app/daily-reminders/id1571791154?itsct=apps_box_badge&amp;itscg=30200" style={{display: 'inline-block', overflow: 'hidden', borderRadius: '13px', width: '250px', height: '83px'}}><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1623283200&h=a40ffafa33597008ba6052b440ff19f8" alt="Download on the App Store" style={{borderRadius: '13px', width: '250px', height: '83px'}}/></a>
			</div>
    </div>
  );
}

export default App;
